import { clsx } from "clsx";

import styles from "../FlowNodes.module.scss";

type NodeProps = {
    children: JSX.Element;
    handleRemove: () => void;
    connectingNodesFrom: boolean;
};

export function FlowNodeRemove({ children, connectingNodesFrom, handleRemove }: NodeProps) {
    return (
        <div
            className={clsx(styles.close, {
                [styles.connectingEdge]: connectingNodesFrom,
            })}
            onClick={handleRemove}
        >
            {children}
        </div>
    );
}
